import { Node } from '@tiptap/core'
import { VueNodeViewRenderer } from '@tiptap/vue-3'
import ImageLoaderView from '../ImageLoaderView.vue'

export const ImageLoader = Node.create({
    name: 'imageLoader',
    group: 'block',
    atom: true,
    selectable: false,

    parseHTML() {
        return [{ tag: 'div[data-image-loader]' }]
    },

    renderHTML() {
        return [
            'div',
            {
                'data-image-loader': '',
                class: 'image-loader-wrapper',
            },
        ]
    },

    addNodeView() {
        return VueNodeViewRenderer(ImageLoaderView)
    },
})
